import React from 'react'

function Carousel() {
  return (
    <div className="carousel carousel-end rounded-box">
   
  </div>
  )
}

export default Carousel
